// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.floorplans.RentalManagerUserPropertyFloorPlanLayoutV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { UserPropertyFloorPlanLayoutDeleteV2RequestDto } from '../..';

export const RentalManagerUserPropertyFloorPlanLayoutV2WebApiHandler_delete_Path =
  '/api/web/v2/users/properties/floorPlans/layouts/delete';

/**
 * Delete a property layout
 */
export const RentalManagerUserPropertyFloorPlanLayoutV2WebApiHandler_delete = (
  postData: UserPropertyFloorPlanLayoutDeleteV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyFloorPlanLayoutDeleteV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyFloorPlanLayoutV2WebApiHandler_delete_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
